import { CommonModule, isPlatformBrowser } from "@angular/common";
import {
  AfterViewInit,
  Component,
  Inject,
  PLATFORM_ID,
  Renderer2,
} from "@angular/core";
import { RouterModule } from "@angular/router";

import { AppBarComponent } from "./shared/components/app-bar/app-bar.component";
import { PageState } from "@core/models/common.interface";
import { PageService } from "@core/services/page.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterModule, AppBarComponent],
  providers: [],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
  pageState = PageState;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private renderer: Renderer2,
    private pageService: PageService
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const loader = this.renderer.selectRootElement(".loader");
      if (loader.style.display != "none") {
        loader.style.display = "none";
      }
    }

    this.getPageState();
  }

  getPageState(): PageState {
    return this.pageService.getPageState();
  }
}
